export default {"src":"/_next/static/image/public/images/flags/flag_224.b395d91e991bcd8c0e1270bf01efe1ce.svg","height":16,"width":24};